<template>
  <div id="svgMatorEditorApp">
    <b-modal
      size="xl"
      v-model="changed"
      title="Svg Mator"
      scrollable
      ref="modal-svg-mator"
      id="modal-svg-mator"
      hide-footer
    >
      <div slot="modal-header" class="w-100">
        <b-button id="svg-btn-back" size="sm" class="float-left" @click="closeModal">
          <i class="fa fa-arrow-left"></i> Retour
        </b-button>
      </div>

      <iframe id="svg-iframe" class="w-100" :src="url"></iframe>
    </b-modal>
  </div>
</template>
<script>
import { mapGetters } from 'vuex';

export default {
  name: 'EditorSvgMatorComponent',
  components: {},
  data() {
    return {
      footer: true,
      url: '',
      changed: false,
    };
  },
  computed: {
    ...mapGetters({
      paramsClient: 'getParamsClients',
    }),
  },

  methods: {
    closeModal() {
      this.changed = false;
      let obj = { resetSvg: true };
      window.frames['svg-iframe'].contentWindow.postMessage(obj, '*');
    },
    loadiframe() {
      let obj = { resetSvg: false };
      window.frames['svg-iframe'].contentWindow.postMessage(obj, '*');
      if (this.paramsClient.display_default_urls && this.paramsClient.display_default_urls.svg_mator) {
        this.url = this.paramsClient.display_default_urls.svg_mator;
      } else {

      }
    },
  },
  created() {
    this.$root.$on('loadiframe', () => {
      this.loadiframe();
    });
  },
  mounted() {
    this.loadiframe();
  },
};
</script>
<style lang="scss">
#svg-btn-back {
}
#svg-iframe {
  border: 0px;
  height: 750px;
}
.svgMatorEditorApp {
  position: relative;
  display: inline-block;
  overflow: hidden;
  max-height: calc(100vh - 5%);
  margin: 5% auto 20px;
  max-width: 1000px;
  width: 90%;
  height: 100%;
}
.imageEditor {
  position: absolute;
  top: 0;
  z-index: 9;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.6);
}
.svg-selectors {
  &__elements {
    cursor: pointer;
    &__ul {
      cursor: pointer;
      &__li {
        list-style: none;
        cursor: pointer;
        padding: 3px;
        box-sizing: content-box !important;
        display: flex;
        align-items: center;
        flex-direction: row;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// EditorSvgMatorComponent.vue?88becee6